import moment from "moment";

export const columns = [
  {
    accessorKey: "approval",
    header: "Approval",
    size: 100,
    enableColumnFilter: false,
    enableSorting: false,
  },
  {
    accessorKey: "serialNumber",
    header: "Serial #",
    size: 150,
  },
  {
    accessorKey: "invoiceDate",
    header: "Invoice Date",
    size: 150,
    accessorFn: (row: any) =>
      row.invoiceDate ? moment(new Date(row.invoiceDate)).format("DD-MM-YYYY") : "",
  },
  {
    accessorKey: "registrationNumber",
    header: "Vehicle",
    size: 140,
  },
  {
    accessorKey: "virNo",
    header: "VIR #",
    size: 180,
  },
  {
    accessorKey: "containerNo",
    header: "Container No",
    size: 180,
  },
  {
    accessorKey: "billNumber",
    header: "BL Number",
    size: 150,
    accessorFn: (row: any) => ` ${row.billNumber || " "}`,
  },
  {
    accessorKey: "cargoType",
    header: "Cargo Type",
    size: 180,
  },
  {
    accessorKey: "paymentTypes",
    header: "Type of Payments",
    size: 220,
    accessorFn: (row: any) => ` ${row.paymentTypes || " "}`,
  },
  { accessorKey: "totalPayment", header: "Total Payment", size: 200 },
  {
    accessorKey: "netAmount",
    header: "Net Amount",
    size: 200,
  },
  { accessorKey: "sTaxAmount", header: "Tax Amount", size: 200 },
  { accessorKey: "discount", header: "Discount", size: 200 },
  { accessorKey: "paymentStatus", header: "Payment Status", size: 220 },
];
